// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { mdi } from "vuetify/iconsets/mdi";
import { customSVGs } from "../assets/custom-svg";

// Vuetify
import { createVuetify } from 'vuetify';
import { sl, en } from 'vuetify/locale';

import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
  theme: false,
  components,
  directives,
  locale: {
    locale: 'sl',
    messages: { sl },
  },
  icons: {
    defaultSet: "mdi",
    sets: {
      mdi,
      custom: customSVGs,
    },
  },
});
// export default createVuetify({
//   theme: false,
//   locale: {
//     locale: 'en-GB',
//     messages: { sl, en },
//   },
// });
